// src/pages/AdsSupport/AdsCallCenter.jsx
import React from "react";
import { useNavigate } from "react-router-dom";

import SupportTabs from "../MyPage/components/SupportTabs";
import { HeaderIconL } from "../../assets/components/HeaderGroup";
import left from "../../assets/icons/Arrow/left.svg";
import { useFixedLayout } from "../../hooks/useFixedLayout";
import info from "../../assets/icons/System/info.svg"

export default function AdsCallCenter() {
  const navigate = useNavigate();
  const { headerRef, headerSpace } = useFixedLayout();

  const handleKakao = () => window.open("https://pf.kakao.com/_hAfxmn", "_blank");  

  const handleHome = () => {
    navigate("/ads/main", { state: { tab: "mypage" }});
  }

  return (
    <div className="flex flex-col h-dvh bg-surface-default">
      {/* 상단 헤더 + 탭 */}
      <div ref={headerRef} className="fixed top-0 left-0 right-0 z-10">
        <HeaderIconL
          icon={left}
          onIconClick={handleHome}
          title="고객지원"
        />
        <SupportTabs />
      </div>

      {/* 본문 */}
      <div
        className="px-[16px]"
        style={{ paddingTop: headerSpace }}
      >

        {/* 카카오톡 섹션 */}
        <section className="pt-[16px]">
          <p className="text-t2 text-text-subtle pb-[24px]">카카오톡</p>

          {/* 라벨 + 액션 버튼 */}
          <div className="flex items-center justify-between pb-[16px]">
            <p className="text-b1 text-text-subtle">
              카카오톡 채팅 상담
            </p>
            <button
              type="button"
              onClick={handleKakao}
              className="text-b1 text-text-primary underline"
            >
              채팅 상담
            </button>
          </div>

          <div className="rounded-[16px] bg-surface-light-subtle px-[16px] py-[12px] flex items-start gap-[6px]">
            <img src={info} alt="" />
            <p className="text-b2 text-text-subtler">
              평일 10:00 ~ 17:00 / 주말, 공휴일 휴무
            </p>
          </div>
        </section>

        {/* 고객센터 섹션 */}
        <section className="pt-[40px]">
          <p className="text-t2 text-text-subtle pb-[24px]">고객센터</p>

          <div className="flex items-center justify-between pb-[16px]">
            <p className="text-b1 text-text-subtle">문의 전화</p>
            <p className="text-b1 text-text-primary">02-2655-9600</p>
          </div>

          <div className="rounded-[16px] bg-surface-light-subtle px-[16px] py-[12px] flex items-start gap-[6px]">
            <img src={info} alt="" />
            <p className="text-b2 text-text-subtler">
              평일 10:00 ~ 17:00 / 주말, 공휴일 휴무
            </p>
          </div>
        </section>
      </div>
    </div>
  );
}
